<script>
  import Empty from '../empty.svelte'
  import { cn } from '@lib/utils'

  let { children, empty = false, emptyMessage, class: className } = $props()
</script>

{#if empty}
  <Empty message={emptyMessage} />
{:else}
  <div class={cn("-mx-6 -mb-4 overflow-x-auto", className)}>
    <table class="w-full table-fixed text-left border-separate border-spacing-0 [&_thead]:bg-transparent [&_th]:px-6 [&_td]:px-6">
      {@render children?.()}
    </table>
  </div>
{/if}
